class DownloadTrackerDateUpdateModel {
    constructor(id, date, userId) {
      this.id = id;
      this.date = date;
      this.userId = userId;
    }
  }
  
  export default DownloadTrackerDateUpdateModel;